module.exports = __webpack_public_path__ + "img/flowers_4.2f748c3.webp";